// src/components/Auth/VerifyEmail.jsx
import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';

function VerifyEmail() {
  const [status, setStatus] = useState('Verifying...');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setStatus('Invalid or missing token.');
      return;
    }

    const verify = async () => {
      console.log('yello');
      try {
        await axiosInstance.get(`/auth/verify-email?token=${token}`);
        setStatus('Email verified successfully! Redirecting to login...');
        setTimeout(() => navigate('/login'), 3000);
      } catch (error) {
        console.error(error);
        setStatus('Verification failed. The token may be invalid or expired.');
      }
    };

    verify();
  }, [searchParams, navigate]);

  return <div>{status}</div>;
}

export default VerifyEmail;
